/**
 * Currency utility — Indian numbering (lakh/crore) per CLAUDE.md "Money & assumptions".
 * Always use these helpers instead of formatting rupee amounts by hand.
 */

const INR_FORMATTER = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/** Plain ₹ formatting with Indian digit grouping, e.g. ₹12,34,567. */
export function formatINR(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return INR_FORMATTER.format(value);
}

/**
 * Compact lakh/crore formatting for headline numbers, e.g. ₹1.26 Cr, ₹45.00 L, ₹8,000.
 * >= 1,00,00,000 -> Cr, >= 1,00,000 -> L, else plain currency.
 */
export function formatINRCompact(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (abs >= 1_00_00_000) {
    return `${sign}₹${(abs / 1_00_00_000).toFixed(2)} Cr`;
  }
  if (abs >= 1_00_000) {
    return `${sign}₹${(abs / 1_00_000).toFixed(2)} L`;
  }
  return INR_FORMATTER.format(value);
}

export function formatPercent(value, digits = 2) {
  // Default to 2 decimals across the app (calculators, policies, returns) — matches the
  // "7.85%" precision requested 13-Feb-2026. Callers can still pass a smaller digit count
  // when a compact tooltip label wants "8%" instead of "8.00%".
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `${(value * 100).toFixed(digits)}%`;
}
